<script setup lang="ts">
import type { ExperienceLocation } from "~/typings/database";

interface ExperienceDatetimeLocationProps {
  startDate: string;
  endDate: string | null;
  location?: ExperienceLocation;
}

defineProps<ExperienceDatetimeLocationProps>();
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-x-4 gap-y-2 text-gray-600 dark:text-gray-400"
  >
    <UiDatetimeLabel :start-date="startDate" :end-date="endDate" />
    <UiLocationLabel
      v-if="location"
      :city="location.city"
      :country="location.country"
    />
  </div>
</template>
